var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#EBF7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9492 10.1758C26.3359 10.6055 26.3359 11.25 25.9492 11.6367L14.6055 22.9805C14.1758 23.4102 13.5312 23.4102 13.1445 22.9805L7.30078 17.1367C6.87109 16.75 6.87109 16.1055 7.30078 15.7188C7.6875 15.2891 8.33203 15.2891 8.71875 15.7188L13.832 20.832L24.4883 10.1758C24.875 9.78906 25.5195 9.78906 25.9062 10.1758H25.9492Z",
    fill: "#74AA85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmRelease);
export default __webpack_public_path__ + "static/media/confirm-release.e30580733bfe8b73699b3e2600d6bfb5.svg";
export { ForwardRef as ReactComponent };